import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';

import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';

@UntilDestroy()
@Component({
  selector: 'remote-connection-install-update-modal',
  templateUrl: './remote-connection-install-update-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionInstallUpdateModalComponent implements AfterViewInit {
  private i18n = inject(I18NextPipe);
  private auth = inject(AuthFacade);
  private cdr = inject(ChangeDetectorRef);
  private route = inject(ActivatedRoute);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly alertType = MbsPopupType;

  public isInstallMode: boolean;
  public computerName: string;
  public isMBSMode: boolean;

  constructor() {
    this.isMBSMode = this.auth.isMBSMode;
  }

  public get title(): string {
    return this.getI18Text('connectTo', this.computerName);
  }

  public get okButton(): string {
    return this.getI18Text(this.isInstallMode ? 'installAndConnect' : 'updateAndConnect');
  }

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.isInstallMode = this.baseModal.data.isInstallMode;
      this.computerName = this.baseModal.data.computerName;
      this.cdr.detectChanges();
    }
  }

  public onCloseButtonClick() {
    if (this.route.snapshot.queryParams.inApp === 'true') {
      return void window.close();
    }

    this.baseModal.close();
  }

  private getI18Text(key: string, param = '') {
    return this.i18n.transform(`shared:computers.modals.${key}`, param ? { param } : {});
  }
}
